import { useConsultation } from '@entities/consultations';
import type React from 'react';

type Props = {
	id: number;
};

export const ConsultationAddress: React.FC<Props> = ({ id }) => {
	const { consultation } = useConsultation(id);

	const getAddress = () => {
		if (!consultation || consultation.schedule.period.address.length === 0) return;

		const address = consultation.schedule.period.address[0];

		return `г. ${address.city}, ул. ${address.street}, д. ${address.house} `;
	};

	return <>{getAddress()}</>;
};
